/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {CardsWidgetUser} from './widgets/CardsWidgetUser'
import {CardsWidgetStatus} from './widgets/CardsWidgetStatus'
import {CardsWidgetServices} from './widgets/CardsWidgetServices'
import {CardsWidgetOperationsWrapper} from './widgets/CardsWidgetOperations'
import {CardsWidgetRemainsWrapper} from './widgets/CardsWidgetRemains'

const DashboardPage: FC = () => {

  return (<div className='row row g-5 g-xl-8 align-items-start'>
        <CardsWidgetUser/>
        <CardsWidgetStatus />
        <CardsWidgetRemainsWrapper />
        <CardsWidgetOperationsWrapper />
        {/* <CardsWidgetBalance /> */}
        {/* <CardsWidgetTasks /> */}
        {/* <CardsWidgetDetails /> */}
        <CardsWidgetServices />
    </div>
  )
}

const DashboardWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Главная</PageTitle>
          <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
